import React, { Component } from "react";
import './layout.css';
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import Header from '../header/header';
import Footer from '../footer/footer';
import Home from '../home/home';
import Javascript from '../javascript/javascript';
import About from '../about/about';

export default class Layout extends Component {

    public render() {

        return(
            <BrowserRouter>
                <section className = "layout">

                    <header>
                        <Header />
                    </header>

                    <main>

                        <Switch>

                        <Route path="/javascript" component={Javascript} exact />
                        <Route path="/about" component={About} exact />
                        <Route path="/" component={Home} exact />
                        <Redirect from ="/*" to="/" exact />

                        </Switch>

                    </main>

                    <footer>
                        <Footer />
                    </footer>

                </section>
            </BrowserRouter>
        );

    }

}